import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'Sidebar',
  data () {
    return {
      linksInputs: [
        { name: 'Home', icon: 'mdi-home', title: 'Home' },
        { name: 'Keywords', icon: 'mdi-format-list-bulleted', title: 'Keywords' },
        { name: 'Pages', icon: 'mdi-format-list-numbered', title: 'Pages' },
        { name: 'Plan', icon: 'mdi-chart-bubble', title: 'Clusters' }
      ],

      linksManage: [
        { name: 'HubDetail', icon: 'mdi-view-grid-plus', title: 'Hubs' },
        { name: 'Mindmap', icon: 'mdi-heart', title: 'Favorites' },
        { name: 'Sprints', icon: 'mdi-calendar-clock', title: 'Sprints' },
        { name: 'ContentEditor', icon: 'mdi-pencil-outline', title: 'Article editor' },
        { name: 'TranslatedArticles', icon: 'mdi-translate', title: 'Translations' },
        { name: 'Report', icon: 'mdi-chart-line', title: 'Report' }
      ],

      linksCreate: [
        { name: 'NewHub', icon: 'mdi-plus-box', title: 'New hub' },
        { name: 'NewArticle', icon: 'mdi-plus', title: 'New article' }
      ],

      linksSaas: [
        { name: 'ClustererPaid', icon: 'mdi-chart-bubble', title: 'SERP clustering' },
        { name: 'WriterPaid', icon: 'mdi-pencil', title: 'AI writer' },
        { name: 'ResearchPaid', icon: 'mdi-magnify', title: 'Keyword research' }
        // { name: 'SaaSSemanticClusterer', icon: 'mdi-tag-multiple', title: 'Semantic clustering' }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'workspaces',
      'contentplans',
      'activeWorkspace',
      'activeContentplan'
    ]),
    workspaceId () {
      return parseInt(this.$route.params.workspaceId)
    },
    contentplanId () {
      return parseInt(this.$route.params.contentplanId)
    },
    unusedContentplans () {
      if (this.workspaces && this.contentplans) {
        return this.workspaces.find(w => w.id === this.workspaceId).paid_plans - this.contentplans.length + 1
      }
    },
    selectableWorkspaces () {
      if (!this.workspaces) return
      return this.workspaces.filter(w => w.id !== this.workspaceId)
    },
    subscriptionTypeIsManaged () {
      return this.activeWorkspace?.type === 'managed'
    }
  },
  methods: {
    ...mapMutations([
      'setSidebar'
    ]),
    async changeWorkspace (workspaceId) {
      this.$router.push({
        name: 'Workspace',
        params: {
          workspaceId
        }
      })

      this.$router.go()
    }
  }
}
